export default {
  groups: [],
  zones: [],
  treeData: [],
  active_zone: null
}
